<ng-container *ngIf="isOffcanvas; else modalTemplate">
  <div appDragClose [dragThreshold]="100" (dragClose)="closeOffcanvas()">
    <div class="drag-handle">
      <div class="drag-indicator"></div>
    </div>
    <div class="offcanvas-header">
      <h5 class="mb-0" id="offcanvasLabel">{{review?.partnerName}}</h5>
      <button type="button" class="btn-close  no-drag" (click)="closeOffcanvas()"></button>
    </div>
  </div>
  <div ngbAutoFocus class="offcanvas-content">
    <app-review [showFullReview]="true" [review]="review"></app-review>

    <div *ngIf="review?.questionDistribution" class="mt-4">
      <div *ngFor="let key of getQuestionKeys(review?.questionDistribution)"
        class="d-flex justify-content-between mb-2">
        <span class="fw-bold">{{ getQuestionText(key) }}:</span>
        <span class="text-end">
          {{ getAverageFromDistribution(review?.questionDistribution![key]) }}/5
        </span>
      </div>
    </div>
  </div>
  <div class="offcanvas-actions d-flex align-items-center w-100"></div>
</ng-container>

<ng-template #modalTemplate>
  <app-modal [title]="review?.partnerName ?? ''">

    <div ngbAutoFocus class="modal-content pt-0" style="overflow: visible;">
      <app-review [showFullReview]="true" [review]="review"></app-review>

      <div *ngIf="review?.questionDistribution" class="mt-4">
        <div *ngFor="let key of getQuestionKeys(review?.questionDistribution)"
          class="d-flex justify-content-between mb-2">
          <span class="fw-bold">{{ getQuestionText(key) }}:</span>
          <span class="text-end">
            {{ getAverageFromDistribution(review?.questionDistribution![key]) }}/5
          </span>
        </div>
      </div>
    </div>

    <div class="modal-actions">
    </div>
  </app-modal>
</ng-template>